import './applied_filter_view.js.coffee'
Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.AppliedMultipleValuesFilterView extends Common.Dashboard.Filters.AppliedFilterView
  visibleValuesIncrease: 3

  initialize: ({filter, isReadOnly}) ->
    super({filter, isReadOnly})
    @visibleValues = 3
    @buttonView = if isReadOnly then @_seeMoreButton() else @_editButton()

  _editButton: ->
    buttonView = new Common.Dashboard.Filters.AppliedFilterEditButtonView()
    @listenTo buttonView, 'edit', => @_seeAll()
    buttonView

  _seeMoreButton: ->
    buttonView = new Common.Dashboard.Filters.AppliedFilterSeeMoreButtonView()
    @listenTo buttonView, 'seeMore', => @_seeMore()
    buttonView

  render: ->
    @buttonView?.$el.detach()
    super()
    @_renderButton() if @_shouldRenderButton()
    @

  _renderButton: ->
    @$el.append @buttonView.render().el

  _shouldRenderButton: ->
    (not @isReadOnly) or @_values().length > @visibleValues

  _displayValues: ->
    @_values().slice(0, @visibleValues)

  _values: ->
    @filter.getValues()

  _seeAll: ->
    throw new Error('_seeAll method from AppliedMultipleValuesFilterView is not implemented')

  _seeMore: ->
    @visibleValues += @visibleValuesIncrease
    @render()
